import React from "react";
import { graphql, useFragment } from "react-relay";

import { faCalendarDay } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";

import { useLinkEventModal } from "~/stream/LinkEventModal";
import { Menu } from "~/ui/menu";

import type { EditLinkedEvent_note$key } from "~/__generated__/EditLinkedEvent_note.graphql";

const noteFragment = graphql`
	fragment EditLinkedEvent_note on Note {
		stream {
			...LinkEventModal_stream
		}
	}
`;

export default function EditLinkedEvent({ note: noteKey }: { note: EditLinkedEvent_note$key }) {
	const note = useFragment(noteFragment, noteKey);

	const openLinkEventModal = useLinkEventModal(note.stream);

	return (
		<Menu.Item icon={faCalendarDay} onSelect={openLinkEventModal}>
			Edit linked event…
		</Menu.Item>
	);
}
